import React from 'react';
import PropTypes from 'prop-types';

import CustomTypes from '../../../types';

import { InputStyled, InputWrapper, LabelInput } from './Input.styled';

const Input = React.forwardRef(({
  label,
  id,
  name, 
  type,
  placeholder,
  modifiers,
  ...props 
}, ref) => (
    <InputWrapper>
      <InputStyled 
        id={id}
        name={name}
        innerRef={ref}
        type={type}
        placeholder={placeholder}
        modifiers={modifiers}
        {...props}
      />
      <LabelInput>{label}</LabelInput>
    </InputWrapper>
));

Input.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  modifiers: CustomTypes.oneOrMore(['', 'success', 'danger']),
};

Input.defaultProps = {
  id: '',
  name: '',
  type: '',
  placeholder: '',
  label: '',
  modifiers: '',
};

export default Input;
